export default require("./node_modules/react/index.js");